import { FC, ReactNode } from 'react';

export interface RouteInternal {
	title?: string;
	path: string;
	exact?: boolean;
	icon?: FC<any>,
	url?: (...args: any[]) => string;
	disabled?: boolean;
	collapsed?: boolean;
	fallback?: React.ReactNode;

	[key: string]: RouteInternal | string | boolean | undefined | Function | ReactNode;
}

export interface RoutesInternal {
	[key: string]: RouteInternal;
}

const defineRoutes = <T extends RoutesInternal>(routes: T): T => routes;

export const routes = defineRoutes({
	root: {
		path: '/',
		auth: {
			path: '/auth',
			login: { path: '/auth/login' },
			forgot: { path: '/auth/forgot' },
			registration: { path: '/auth/registration' },
			verification: { path: '/auth/verification/:code' },
		},
		home: {
			path: '/home',
			profile: {
				path: '/home/profile',
			},
			groups: {
				path: '/home',
				exact: true,
			},
			favorite: {
				path: '/home/favorite',
			},
			userBoxes: {
				path: '/home/boxes',
			},
			createGroup: {
				path: '/home/create',
			},
			group: {
				path: '/home/box/:id',
				url: (group: string) => `/home/box/${group}`,
				main: {
					path: '/home/box/:id',
					url: (group: string) => `/home/box/${group}`,
				},
				admin: {
					path: '/home/box/:id/admin',
					url: (group?: string) => `/home/box/${group}/admin`,
				},
				slave: {
					path: '/home/box/:id/slave',
					url: (group?: string) => `/home/box/${group}/slave`,
				},
			},
		},
	},
});
